import { useLocation } from 'react-router-dom';
import { WHOLESALE_PREFIX } from 'enums/publicRoutes';

function useMarketType() {
  const { pathname } = useLocation();
  const isWholeSale = pathname.includes(WHOLESALE_PREFIX);

  const isEmarket = isWholeSale ? false : true;
  const marketType = isWholeSale ? 'WHOLESALE' : 'EMARKET';

  return { marketType, isEmarket };
}

export default useMarketType;
